import { apiRequest, buildApiUrl } from '../utils/api';

// Servicio para manejar el kanban
export class KanbanService {
  // Obtener datos del kanban
  static async getKanbanData() {
    try {
      const response = await apiRequest(buildApiUrl('/kanban'), {
        method: 'GET'
      });
      
      console.log('✅ Respuesta del kanban:', response);
      
      if (response.response && response.response.content && response.response.content.kanban) {
        return {
          success: true,
          data: response.response.content.kanban,
          operationId: response.operationId
        };
      } else {
        throw new Error('No kanban data found in response');
      }
    } catch (error) {
      console.error('Error fetching kanban data:', error);
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }
}

// Función helper para obtener color según el estado
const getProjectColor = (status) => {
  const colorMap = {
    'pending': 'blue',
    'progress': 'yellow',
    'in-progress': 'yellow',
    'completed': 'green',
    'backlog': 'gray',
    'cancelled': 'red'
  };
  return colorMap[status] || 'blue';
};

// Función helper para obtener icono según el nombre
const getProjectIcon = (name) => {
  const iconMap = {
    'api': '🔌',
    'login': '🔐',
    'onboarding': '🚀',
    'testing': '🧪',
    'qa': '🧪',
    'mobile': '📱',
    'web': '🌐',
    'backend': '⚙️',
    'frontend': '🎨',
    'tec': '💻',
    'dashboard': '📊',
    'calendario': '📅',
    'kanban': '📋',
    'etiqueta': '🏷️'
  };
  
  const lowerName = name.toLowerCase();
  for (const [key, icon] of Object.entries(iconMap)) {
    if (lowerName.includes(key)) {
      return icon;
    }
  }
  
  return '📋'; // Icono por defecto
};

// Función helper para formatear proyecto del kanban
const formatKanbanProject = (project) => {
  if (!project) return null;
  
  return {
    id: project.id?.toString() || String(Date.now()),
    name: project.name || 'Sin nombre',
    description: project.description || 'Sin descripción',
    status: project.status || 'pending',
    initialDate: project.initial_date,
    finalDate: project.final_date,
    corporationId: project.corporation_id,
    progress: project.progress || 0,
    tasksCount: project.tasks || 0,
    participants: project.participants || [],
    tags: project.tags || [],
    color: getProjectColor(project.status || 'pending'),
    icon: getProjectIcon(project.name || '')
  };
};

// Función helper para formatear los datos del kanban
export const formatKanbanData = (kanbanData) => {
  if (!kanbanData) {
    console.warn('⚠️ formatKanbanData recibió datos nulos, devolviendo estructura vacía');
    return {
      pending: [],
      progress: [],
      completed: []
    };
  }
  
  // SIEMPRE devolver las 3 columnas, aunque estén vacías
  const result = {
    pending: (kanbanData.pending || []).map(formatKanbanProject).filter(Boolean),
    progress: (kanbanData.progress || []).map(formatKanbanProject).filter(Boolean),
    completed: (kanbanData.completed || []).map(formatKanbanProject).filter(Boolean)
  };
  
  console.log('✅ formatKanbanData resultado:', {
    pending: result.pending.length,
    progress: result.progress.length,
    completed: result.completed.length
  });
  
  return result;
};

